export default {
  documentsLinks: {
    id: 'legal_layout_previous_documents_links',
    defaultMessage: 'Links to previous versions',
  },
}
